/**
 * Core game state types
 */
export var GamePhase;
(function (GamePhase) {
    GamePhase["WAITING"] = "waiting";
    GamePhase["PROMPT_SELECTION"] = "prompt_selection";
    GamePhase["OPENER_BUILDING"] = "opener_building";
    GamePhase["PRESENTER_INTRO"] = "presenter_intro";
    GamePhase["PRESENTING"] = "presenting";
    GamePhase["ROUND_END"] = "round_end";
    GamePhase["GAME_END"] = "game_end";
})(GamePhase || (GamePhase = {}));
//# sourceMappingURL=game.js.map